import React from "react";

import {
  MustUpgradePassMessageModal,
  MustUpgradePassMessageModalProps
} from "../../MustUpgradePassMessage";

export type Props = Omit<MustUpgradePassMessageModalProps, "message">;

export default function NoSubscriptionForCourseMessage(props: Props) {
  return (
    <MustUpgradePassMessageModal
      {...props}
      message={`You need to purchase a premium package to access this course.`}
    />
  );
}
